import { Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { BannerCouponName } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import { VA_MONEY_BACK_GUARANTEE } from "constants/influencer";
import { trackEvent } from "utils/tracking";

interface Props {
  plan: Plans;
}

const VATerms = ({ plan }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { subscription, plans } = useContext(SubscriptionContext);
  const trackTermsAndCondition = () => {
    trackEvent("Terms and Conditions for VA Plan Clicked", { plan });
  };

  const isMoneyBackGuarantee =
    plan === Plans.VA_YEARLY &&
    subscription?.bannerPromoCode?.couponName ===
      BannerCouponName.money_back_guarantee;

  if (!plans) return <></>;
  return (
    <Typography>
      <Link
        href={
          isMoneyBackGuarantee
            ? VA_MONEY_BACK_GUARANTEE
            : plans[plan]?.terms_and_conditions
        }
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackTermsAndCondition}
        sx={
          isMobileScreen
            ? {
                color: "secondary.dark",
                fontSize: 14,
                textDecoration: "none",
              }
            : {
                color: "purple.main",
                fontSize: 10,
                textDecoration: "underline",
                textDecorationColor: "purple.main",
              }
        }
      >
        {isMoneyBackGuarantee ? "Money-Back" : ""} Terms & Conditions
      </Link>
    </Typography>
  );
};

export default VATerms;
